import choco from '@/assets/pos-starter/yfood-classic-choco.png'
import vanilla from '@/assets/pos-starter/yfood-smooth-vanilla.png'
import berry from '@/assets/pos-starter/yfood-fresh-berry.png'
import banana from '@/assets/pos-starter/yfood-happy-banana.png'
import coffee from '@/assets/pos-starter/yfood-cold-brew-coffee.png'
import wheyVanilla from '@/assets/pos-starter/vast-whey-1.jpg'
import wheyChoco from '@/assets/pos-starter/vast-whey-2.jpg'
import casein from '@/assets/pos-starter/casein-1.png'
import booster from '@/assets/pos-starter/vast-booster-1.jpg'
import wristband from './pos-wristband.png'

export default { 'yfood-classic-choco': choco, 'yfood-smooth-vanilla': vanilla, 'yfood-fresh-berry': berry,
  'yfood-happy-banana': banana, 'yfood-cold-brew-coffee': coffee, 'vast-whey-1': wheyVanilla, 'vast-whey-2': wheyChoco,
  'casein-1': casein, 'vast-booster-1': booster, wristband }
